import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { FadeLoader } from "react-spinners";

// ⬇️ PROMIJENI: ID parent stranice pod kojom su child pages "diplomirali"
const DIPLOMIRALI_PARENT_ID = 0;

const DiplomiraliASU = () => {
  const [docenti, setDocenti] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    async function dohvatiSveStranice() {
      try {
        setLoading(true);
        setError(false);

        let sve = [];
        let page = 1;
        let totalPages = 1;

        while (page <= totalPages) {
          const res = await axios.get("https://www.asu.unsa.ba/v2/index.php", {
            params: {
              rest_route: "/wp/v2/pages",
              parent: DIPLOMIRALI_PARENT_ID || undefined, // ako je 0, ne šaljemo parent
              per_page: 100,
              page,
              _embed: true,
              _fields: "id,title,acf,_embedded,menu_order",
              acf_format: "standard",
            },
          });

          sve = sve.concat(res.data);
          totalPages = Number(res.headers["x-wp-totalpages"] || 1);
          page++;
        }

        return sve;
      } catch (err) {
        console.error("Greška prilikom dohvata stranica:", err);
        throw err;
      } finally {
        setLoading(false);
      }
    }

    dohvatiSveStranice()
      .then((stranice) => {
        setDocenti(stranice);
      })
      .catch(() => setError(true));
  }, []);

  // Kopija + sortiranje (ne mutira state)
  const sorted = useMemo(() => {
    return [...docenti].sort((a, b) => {
      const ao = Number(a?.menu_order ?? 0);
      const bo = Number(b?.menu_order ?? 0);
      if (ao !== bo) return ao - bo;

      // fallback: po naslovu A-Z
      const at = (a?.title?.rendered ?? "").toLowerCase();
      const bt = (b?.title?.rendered ?? "").toLowerCase();
      return at.localeCompare(bt);
    });
  }, [docenti]);

  return (
    <div className="container drugaSekcija dekanat">
      <div className="container dekanat">
        <div className="container drugaSekcija">
          <h4>STUDENTI | DIPLOMIRALI NA ASU</h4>

          {loading ? (
            <div
              className="text-center"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "70vh",
              }}
            >
              <FadeLoader color="#123abc" loading={loading} />
            </div>
          ) : error ? (
            <p style={{ padding: 20 }}>Podaci nisu dostupni.</p>
          ) : (
            <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 row-cols-xl-4">
              {sorted.map((el) => {
                const img =
                  el?._embedded?.["wp:featuredmedia"]?.[0]?.media_details?.sizes
                    ?.medium?.source_url ||
                  el?._embedded?.["wp:featuredmedia"]?.[0]?.source_url ||
                  "";

                return (
                  <div className="col mb-4" key={el.id} style={{ width: "15%" }}>
                    <Link to={`/studenti-diplomirali/${el.id}`} className="card-link">
                      <div className="card" style={{ backgroundColor: "unset", border: 0 }}>
                        {img ? (
                          <img
                            className="card-img-top img-fluid img-thumbnail profe"
                            alt={el?.title?.rendered || "Student"}
                            style={{
                              width: 150,
                              height: 150,
                              objectFit: "cover",
                              objectPosition: "center 10%",
                            }}
                            src={img}
                          />
                        ) : (
                          <div style={{ width: 150, height: 150 }} />
                        )}

                        <div className="card-body" style={{ padding: 0, paddingLeft: 2 }}>
                          <p style={{ fontSize: 18 }}>
                            {el?.acf?.titula ? `${el.acf.titula} ` : ""}
                            {el?.title?.rendered || "—"}
                          </p>
                        </div>
                      </div>
                    </Link>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DiplomiraliASU;
